import { render, staticRenderFns } from "./AddOtherMemberDialog.vue?vue&type=template&id=0e6520ca&scoped=true&"
import script from "./AddOtherMemberDialog.vue?vue&type=script&lang=js&"
export * from "./AddOtherMemberDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOtherMemberDialog.vue?vue&type=style&index=0&id=0e6520ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6520ca",
  null
  
)

export default component.exports